import React, {useContext, useEffect, useState} from "react";
import moment from "moment";
import LoaderCircle from "../../../tools/loader/LoaderCircle";
import StoreController from "../../../../stories/_client/Stores/StoreController";
import * as echarts from "echarts";
import AuthController from "../../../../stories/_auth/Auth/AuthController";
import "../../../../css/page/contents/client/Fragmentation.css";

const Fragmentation = () => {
	const [ fragmentation, setFragmentation ] = useState(null);

	const getFragmentation = () => {
		if (!AuthController.hasRules("admin")) return;

		const controller = new StoreController();
		controller._callback = returnGetFragmentation;
		controller.fragmentation();
	}
    const returnGetFragmentation = (result, error, status) => {
        switch (status) {
            case 200:
				setFragmentation(result.data);
                break;
            default:
                break;
        }
    }
	const buildFragmentation = () => {
		if (!AuthController.hasRules("admin")) return;

		return <div className={"fragmentation"}>
			<h1 className={"title"}>Répartition des versions</h1>
			<div id={"chart"} className={"chart"} />
		</div>;
	}
	const buildChartOption = () => {
		if (fragmentation === null) return;

		let chartDom = document.getElementById('chart');
		let myChart = echarts.init(chartDom);
		let option;
		let datas = [];

		for (let i in fragmentation) {
			datas.push({
				value: parseInt(fragmentation[i].total),
				name: fragmentation[i].version
			})
		}

		option = {
			tooltip: {
				trigger: 'item'
			},
			legend: {
				show: false
			},
			top: '-20%',
			width: 'auto',
			height: 400,
			radius: "90%",
			series: [
				{
					name: 'Versions SkyTill',
					type: 'pie',
					radius: ['40%', '70%'],
					//center: ['50%', '70%'],
					itemStyle: {
						borderRadius: 5,
						borderColor: '#fff',
						borderWidth: 2
					},
					emphasis: {
						label: {
							show: true,
							fontWeight: 'bold'
						}
					},
					startAngle: 180,
					endAngle: 360,
					data: datas
				}
			]
		};

		option && myChart.setOption(option);
	}

	useEffect(() => {
		getFragmentation();
	}, []);
	useEffect(() => {
		buildChartOption();
	}, [fragmentation]);

    return buildFragmentation();
}

export default Fragmentation;